import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireQuizQuestion} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';

@Injectable()
export class QuizQuestionService implements CrudService<UmpireQuizQuestion> {
  constructor(readonly http: TisaUmpireHttpService) {}

  delete(id: string): Observable<void> {
    return this.http.delete(`/quiz_questions/${id}`);
  }

  create(
    body: Partial<UmpireQuizQuestion>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizQuestion>> {
    return this.http.post<JsonApiResponse<UmpireQuizQuestion>>(
      '/quiz_questions',
      serialize({stuff: body}),
      {
        params: objectToHttpParams(params),
      },
    );
  }

  update(
    body: Partial<UmpireQuizQuestion>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizQuestion>> {
    return this.http
      .patch<JsonApiResponse<UmpireQuizQuestion>>(
        `/quiz_questions/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
